import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'om-divider',
  imports: [CommonModule],
  templateUrl: './divider.html',
  styleUrl: './divider.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Divider {
  /** Optional text shown between the lines (e.g. "or with your email") */
  text = input<string>('');
}
